import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/title-icon.png';
const _withScopeId = n => (_pushScopeId("data-v-2db7e753"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container runtime-monitor"
};
const _hoisted_2 = {
  class: "search-container toolbar"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"toolbar-left\" data-v-2db7e753><div class=\"title-group\" data-v-2db7e753><img src=\"" + _imports_0 + "\" alt=\"\" class=\"title-group-icon\" data-v-2db7e753><div class=\"title-group-text\" data-v-2db7e753><div class=\"page-title\" data-v-2db7e753><span data-v-2db7e753>运行监控</span></div><span class=\"monitor-note\" data-v-2db7e753>监控仅观察方法执行：正常返回不代表业务全部成功；业务数量未采集。数据过期显示未知。</span></div></div></div>", 1);
const _hoisted_4 = {
  class: "filters"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "filter-label"
}, "运行实例", -1));
const _hoisted_6 = {
  class: "filter-switch"
};
const _hoisted_7 = {
  class: "stats"
};
const _hoisted_8 = {
  class: "stat-card stat-danger"
};
const _hoisted_9 = {
  class: "stat-icon"
};
const _hoisted_10 = {
  class: "stat-info"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "异常任务", -1));
const _hoisted_12 = {
  class: "stat-value"
};
const _hoisted_13 = {
  class: "stat-card stat-danger"
};
const _hoisted_14 = {
  class: "stat-icon"
};
const _hoisted_15 = {
  class: "stat-info"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "异常线程池", -1));
const _hoisted_17 = {
  class: "stat-value"
};
const _hoisted_18 = {
  class: "stat-card stat-warning"
};
const _hoisted_19 = {
  class: "stat-icon"
};
const _hoisted_20 = {
  class: "stat-info"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "数据过期/未知", -1));
const _hoisted_22 = {
  class: "stat-value"
};
const _hoisted_23 = {
  class: "stat-card stat-info"
};
const _hoisted_24 = {
  class: "stat-icon"
};
const _hoisted_25 = {
  class: "stat-info"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "累计丢弃记录", -1));
const _hoisted_27 = {
  class: "stat-value"
};
const _hoisted_28 = {
  class: "stat-card stat-primary"
};
const _hoisted_29 = {
  class: "stat-icon"
};
const _hoisted_30 = {
  class: "stat-info"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "最近采集", -1));
const _hoisted_32 = {
  class: "stat-value"
};
const _hoisted_33 = {
  class: "table-container-wrapper monitor-content-wrapper"
};
const _hoisted_34 = {
  class: "muted"
};
const _hoisted_35 = {
  class: "muted"
};
const _hoisted_36 = {
  class: "muted"
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  key: 1
};
const _hoisted_39 = {
  key: 2
};
const _hoisted_40 = {
  key: 3
};
const _hoisted_41 = {
  class: "history-filters"
};
const _hoisted_42 = {
  class: "muted"
};
import { computed, nextTick, onActivated, onDeactivated, onMounted, onUnmounted, ref, watch } from 'vue';
import * as echarts from 'echarts';
import { Refresh, WarningFilled, Warning, Clock, InfoFilled, Monitor } from '@element-plus/icons-vue';
import { getMonitorHistory, getMonitorOverview } from '@/api/runtimeMonitor';
export default {
  __name: 'index',
  setup(__props) {
    const overview = ref({}),
      instance = ref(''),
      tab = ref('TASK'),
      automatic = ref(true),
      loading = ref(false),
      error = ref('');
    const drawer = ref(false),
      selected = ref(null),
      detailType = ref('TASK'),
      history = ref({
        list: [],
        total: 0
      });
    const historyLoading = ref(false),
      historyError = ref(''),
      page = ref(1),
      range = ref([]),
      poolFilter = ref(''),
      chartElement = ref(null);
    const labels = {
      NORMAL: '正常',
      BUSY: '队列繁忙',
      ALERT: '异常',
      REJECT: '任务被拒绝',
      DISCARD: '任务被丢弃',
      WAITING: '等待执行',
      RETURNED: '正常返回',
      FAILED: '执行异常',
      RUNNING: '运行中',
      TIMEOUT: '执行超时',
      MISSED: '疑似漏跑'
    };
    const sendLabels = {
      SENT: '已发送',
      FAILED: '发送失败（不重试）',
      DISABLED: '短信未启用',
      NOT_CONFIGURED: '短信配置不完整'
    };
    const now = ref(Date.now());
    let timer,
      ageTimer,
      chart,
      sequence = 0,
      historySequence = 0,
      active = true,
      serverOffset = 0;
    const time = value => value ? new Date(value).toLocaleString('zh-CN', {
      hour12: false
    }) : '—';
    const stale = row => !row.createTime || now.value - row.createTime > Math.max(180000, (overview.value.local?.sampleSeconds || 60) * 3000);
    const status = row => stale(row) ? '未知（数据过期）' : labels[row.status] || row.status;
    const isAbnormal = row => ['FAILED', 'TIMEOUT', 'MISSED', 'ALERT', 'REJECT', 'DISCARD'].includes(row.status);
    const tagType = row => stale(row) ? 'info' : isAbnormal(row) ? 'danger' : row.status === 'BUSY' ? 'warning' : 'success';
    const allRows = computed(() => [...(overview.value.tasks || []), ...(overview.value.pools || [])]);
    const staleCount = computed(() => allRows.value.filter(stale).length);
    const abnormalTasks = computed(() => (overview.value.tasks || []).filter(row => !stale(row) && isAbnormal(row)).length);
    const abnormalPools = computed(() => (overview.value.pools || []).filter(row => !stale(row) && isAbnormal(row)).length);
    const instanceOptions = computed(() => [...new Set((overview.value.instances || []).map(row => row.instanceId))]);
    const displayPools = computed(() => (overview.value.pools || []).filter(row => !poolFilter.value || row.name === poolFilter.value));
    const lastSample = computed(() => Math.max(0, ...allRows.value.map(row => row.createTime || 0)));
    const dropped = computed(() => (overview.value.health || []).reduce((sum, row) => sum + (row.dropped || 0), 0));
    async function refresh() {
      const requestId = ++sequence;
      loading.value = true;
      try {
        const data = await getMonitorOverview(instance.value || '');
        if (requestId === sequence && active) {
          overview.value = data;
          serverOffset = data.serverTime - Date.now();
          now.value = data.serverTime;
          error.value = '';
        }
      } catch (e) {
        if (requestId === sequence && active) error.value = '监控数据读取失败。请检查权限、监控开关和数据库表；已有数据可能过期。';
      } finally {
        if (requestId === sequence) loading.value = false;
      }
    }
    async function openDetail(row, type) {
      selected.value = row;
      detailType.value = type;
      page.value = 1;
      history.value = {
        list: [],
        total: 0
      };
      range.value = [new Date(Date.now() - 86400000), new Date()];
      drawer.value = true;
      await loadHistory();
    }
    function searchHistory() {
      page.value = 1;
      loadHistory();
    }
    async function loadHistory() {
      if (!selected.value || !range.value?.length) return;
      const from = +range.value[0],
        to = +range.value[1];
      if (to < from || to - from > 30 * 86400000) {
        historyError.value = '请选择不超过 30 天的时间范围';
        return;
      }
      const requestId = ++historySequence;
      historyLoading.value = true;
      historyError.value = '';
      try {
        const data = await getMonitorHistory({
          instance: selected.value.instanceId,
          boot: detailType.value === 'POOL' ? selected.value.bootId : '',
          object: selected.value.name,
          type: detailType.value,
          page: page.value,
          size: 50,
          from,
          to
        });
        if (requestId !== historySequence || !drawer.value) return;
        history.value = data;
        await nextTick();
        renderChart();
      } catch (e) {
        if (requestId === historySequence) {
          history.value = {
            list: [],
            total: 0
          };
          historyError.value = '历史数据读取失败';
        }
      } finally {
        if (requestId === historySequence) historyLoading.value = false;
      }
    }
    function renderChart() {
      chart?.dispose();
      chart = null;
      if (detailType.value !== 'POOL' || !chartElement.value) return;
      const rows = [...history.value.list].reverse();
      chart = echarts.init(chartElement.value);
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['活跃线程', '排队数量', '拒绝增量']
        },
        grid: {
          left: 50,
          right: 20,
          bottom: 55
        },
        xAxis: {
          type: 'category',
          data: rows.map(row => time(row.createTime))
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: ['active', 'queued', 'rejectedDelta'].map((key, index) => ({
          name: ['活跃线程', '排队数量', '拒绝增量'][index],
          type: 'line',
          data: rows.map(row => row[key]),
          connectNulls: false
        }))
      });
    }
    function resize() {
      chart?.resize();
    }
    function linkPool(pool) {
      instance.value = selected.value.instanceId;
      poolFilter.value = pool;
      tab.value = 'POOL';
      drawer.value = false;
      refresh();
    }
    function start() {
      active = true;
      clearInterval(timer);
      clearInterval(ageTimer);
      refresh();
      ageTimer = setInterval(() => {
        now.value = Date.now() + serverOffset;
      }, 10000);
      timer = setInterval(() => {
        if (automatic.value && !loading.value && !document.hidden) refresh();
      }, 60000);
    }
    function stop() {
      active = false;
      clearInterval(timer);
      clearInterval(ageTimer);
      sequence++;
      historySequence++;
    }
    watch(drawer, value => {
      if (!value) {
        historySequence++;
        chart?.dispose();
        chart = null;
      }
    });
    onMounted(() => {
      start();
      window.addEventListener('resize', resize);
    });
    onActivated(() => {
      if (!active) start();
    });
    onDeactivated(stop);
    onUnmounted(() => {
      stop();
      chart?.dispose();
      window.removeEventListener('resize', resize);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_alert = _resolveComponent("el-alert");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_select, {
        modelValue: instance.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => instance.value = $event),
        clearable: "",
        placeholder: "所有实例",
        size: "default",
        onChange: refresh
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(instanceOptions), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_switch, {
        modelValue: automatic.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => automatic.value = $event),
        "active-text": "自动刷新",
        "inline-prompt": ""
      }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        class: "refreshBtn",
        icon: _unref(Refresh),
        loading: loading.value,
        onClick: refresh
      }, {
        default: _withCtx(() => [_createTextVNode("刷新")]),
        _: 1
      }, 8, ["icon", "loading"])])]), error.value ? (_openBlock(), _createBlock(_component_el_alert, {
        key: 0,
        title: error.value,
        type: "error",
        "show-icon": "",
        closable: false
      }, null, 8, ["title"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(abnormalTasks)), 1)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(Warning))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(abnormalPools)), 1)])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(Clock))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(staleCount)), 1)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(dropped)), 1)])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(Monitor))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString(time(_unref(lastSample))), 1)])])]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_el_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => tab.value = $event),
        class: "monitor-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "定时任务",
          name: "TASK"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: overview.value.tasks || [],
            class: "monitor-table",
            stripe: "",
            "empty-text": "暂无固定任务数据；请确认已启用监控及当前环境的任务"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "65"
            }), _createVNode(_component_el_table_column, {
              label: "任务",
              "min-width": "230"
            }, {
              default: _withCtx(({
                row
              }) => [_createElementVNode("div", null, _toDisplayString(row.displayName), 1), _createElementVNode("small", _hoisted_34, _toDisplayString(row.name), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "instanceId",
              label: "实例",
              "min-width": "140"
            }), _createVNode(_component_el_table_column, {
              label: "状态",
              width: "130"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_tag, {
                type: tagType(row)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(status(row)), 1)]),
                _: 2
              }, 1032, ["type"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "schedule",
              label: "执行规则",
              "min-width": "180"
            }), _createVNode(_component_el_table_column, {
              label: "最近开始",
              width: "170"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(time(row.started)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "最近结束",
              width: "170"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(time(row.ended)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "耗时",
              width: "100"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(row.duration) + " ms", 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "业务数量",
              width: "100"
            }, {
              default: _withCtx(() => [_createTextVNode("未采集")]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "90",
              fixed: "right"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: $event => openDetail(row, 'TASK')
              }, {
                default: _withCtx(() => [_createTextVNode("详情")]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, loading.value]])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "线程池",
          name: "POOL"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(displayPools),
            class: "monitor-table",
            stripe: "",
            "empty-text": "暂无线程池采样"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "65"
            }), _createVNode(_component_el_table_column, {
              label: "线程池",
              "min-width": "220"
            }, {
              default: _withCtx(({
                row
              }) => [_createElementVNode("div", null, _toDisplayString(row.displayName || row.name), 1), _createElementVNode("small", _hoisted_35, _toDisplayString(row.name), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "instanceId",
              label: "实例",
              "min-width": "140"
            }), _createVNode(_component_el_table_column, {
              label: "状态",
              width: "110"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_tag, {
                type: tagType(row)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(status(row)), 1)]),
                _: 2
              }, 1032, ["type"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "核心 / 最大",
              width: "110"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(row.core) + " / " + _toDisplayString(row.max ?? '不适用'), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "活跃 / 当前",
              width: "110"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(row.active) + " / " + _toDisplayString(row.size), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "队列 / 容量",
              width: "120"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(row.queued) + " / " + _toDisplayString(row.capacity < 0 ? '无界' : row.capacity), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "policy",
              label: "拒绝策略",
              "min-width": "150"
            }), _createVNode(_component_el_table_column, {
              label: "拒绝增量",
              width: "90"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(row.rejectedDelta), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "实际丢弃增量",
              width: "120"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(row.discardedDelta ?? '未知'), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "90",
              fixed: "right"
            }, {
              default: _withCtx(({
                row
              }) => [_createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: $event => openDetail(row, 'POOL')
              }, {
                default: _withCtx(() => [_createTextVNode("详情")]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, loading.value]]), poolFilter.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            onClick: _cache[2] || (_cache[2] = $event => poolFilter.value = '')
          }, {
            default: _withCtx(() => [_createTextVNode("取消关联线程池筛选")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_collapse, {
        class: "table-container-wrapper notices"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
          title: "最近 50 条告警及短信发送结果",
          name: "notices"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: overview.value.notices || [],
            class: "monitor-table",
            stripe: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "时间",
              width: "180"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(time(row.createTime)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "message",
              label: "内容",
              "min-width": "300"
            }), _createVNode(_component_el_table_column, {
              label: "短信结果",
              width: "150"
            }, {
              default: _withCtx(({
                row
              }) => [_createTextVNode(_toDisplayString(sendLabels[row.sendStatus] || row.sendStatus), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => drawer.value = $event),
        title: selected.value?.displayName || selected.value?.name || '详情',
        size: "85%",
        onOpened: resize
      }, {
        default: _withCtx(() => [selected.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("p", _hoisted_36, [_createTextVNode("实例 " + _toDisplayString(selected.value.instanceId), 1), detailType.value === 'POOL' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(" · 进程 " + _toDisplayString(selected.value.bootId), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(" · 该实例全部启动周期的执行历史")], 64))]), detailType.value === 'TASK' ? (_openBlock(), _createElementBlock("p", _hoisted_37, "最近异常：" + _toDisplayString(selected.value.error || '无向外抛出的异常'), 1)) : _createCommentVNode("", true), detailType.value === 'TASK' ? (_openBlock(), _createElementBlock("p", _hoisted_38, "预计下次开始：" + _toDisplayString(time(selected.value.nextExpected)) + " · 超时阈值：" + _toDisplayString(selected.value.timeoutMs / 1000) + " 秒", 1)) : _createCommentVNode("", true), selected.value.pools?.length ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createTextVNode("关联线程池："), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selected.value.pools, pool => {
          return _openBlock(), _createBlock(_component_el_button, {
            key: pool,
            link: "",
            type: "primary",
            onClick: $event => linkPool(pool)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(pool), 1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))])) : _createCommentVNode("", true), detailType.value === 'POOL' ? (_openBlock(), _createElementBlock("p", _hoisted_40, "累计拒绝 " + _toDisplayString(selected.value.rejected) + " · 调用方执行 " + _toDisplayString(selected.value.callerRuns) + " · 实际丢弃 " + _toDisplayString(selected.value.discarded ?? '未知') + " · 线程池内完成 " + _toDisplayString(selected.value.completed), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_date_picker, {
          modelValue: range.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => range.value = $event),
          type: "datetimerange",
          "start-placeholder": "开始时间",
          "end-placeholder": "结束时间"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          loading: historyLoading.value,
          onClick: searchHistory
        }, {
          default: _withCtx(() => [_createTextVNode("查询")]),
          _: 1
        }, 8, ["loading"])]), historyError.value ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 4,
          title: historyError.value,
          type: "error",
          closable: false
        }, null, 8, ["title"])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_42, _toDisplayString(detailType.value === 'POOL' ? '趋势图展示当前页采样点，不代表采样间的瞬时峰值。' : '每次执行一条记录，开始插入、结束更新。未结束可能是仍在运行、中断或结束更新丢失。'), 1), detailType.value === 'POOL' ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          ref_key: "chartElement",
          ref: chartElement,
          class: "chart"
        }, null, 512)) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: history.value.list,
          class: "monitor-table",
          stripe: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: detailType.value === 'TASK' ? '开始时间' : '采样时间',
            width: "175"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(time(detailType.value === 'TASK' ? row.started : row.createTime)), 1)]),
            _: 1
          }, 8, ["label"]), detailType.value === 'TASK' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "结束时间",
            width: "175"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(time(row.ended)), 1)]),
            _: 1
          })) : _createCommentVNode("", true), detailType.value === 'TASK' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            prop: "id",
            label: "记录编号",
            "min-width": "100"
          })) : _createCommentVNode("", true), detailType.value === 'TASK' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            prop: "displayName",
            label: "任务名称",
            "min-width": "160"
          })) : _createCommentVNode("", true), detailType.value === 'TASK' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 3,
            label: "结果",
            width: "160"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(row.status === 'RUNNING' ? '未结束' : labels[row.status] || row.status) + _toDisplayString(row.timedOut ? '（曾超时）' : ''), 1)]),
            _: 1
          })) : _createCommentVNode("", true), detailType.value === 'TASK' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 4,
            prop: "error",
            label: "异常摘要",
            "min-width": "200"
          })) : _createCommentVNode("", true), detailType.value === 'TASK' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 5,
            label: "耗时"
          }, {
            default: _withCtx(({
              row
            }) => [_createTextVNode(_toDisplayString(row.duration == null ? '—' : row.duration + ' ms'), 1)]),
            _: 1
          })) : _createCommentVNode("", true), detailType.value === 'POOL' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 6,
            prop: "active",
            label: "活跃线程"
          })) : _createCommentVNode("", true), detailType.value === 'POOL' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 7,
            prop: "queued",
            label: "排队数量"
          })) : _createCommentVNode("", true), detailType.value === 'POOL' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 8,
            prop: "rejectedDelta",
            label: "拒绝增量"
          })) : _createCommentVNode("", true), detailType.value === 'POOL' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 9,
            prop: "callerDelta",
            label: "调用方执行增量"
          })) : _createCommentVNode("", true), detailType.value === 'POOL' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 10,
            prop: "discardedDelta",
            label: "丢弃增量"
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, historyLoading.value]]), _createVNode(_component_el_pagination, {
          "current-page": page.value,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => page.value = $event),
          background: "",
          "page-size": 50,
          total: history.value.total,
          layout: "total, prev, pager, next",
          onCurrentChange: loadHistory
        }, null, 8, ["current-page", "total"])], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};